import React, { Suspense, useLayoutEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

import { Provider } from "react-redux";
import { persistor, store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";

import App from "./App";
import { SplashScreen } from "./components/splash-screen/splash-screen.component";

import "./assets/styles/index.scss";
import "react-spring-bottom-sheet/dist/style.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "mapir-react-component/dist/index.css";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			staleTime: Infinity,
		},
	},
});

const Main = () => {
	const rootContainer = useRef();

	useLayoutEffect(() => {
		const handleScreenSizeChange = () => {
			const userScreenHeight =
				window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

			if (rootContainer.current) {
				rootContainer.current.style.height = `${userScreenHeight}px`;
			}
		};

		handleScreenSizeChange();

		window.addEventListener("resize", handleScreenSizeChange);
	}, []);

	return (
		<div className="main-container" ref={rootContainer}>
			<div className="content-container">
				<App />
			</div>
		</div>
	);
};

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<PersistGate loading={SplashScreen} persistor={persistor}>
				<Suspense fallback={<SplashScreen />}>
					<ToastContainer
						position="bottom-center"
						autoClose={3500}
						icon={false}
						hideProgressBar
						closeOnClick
						rtl
						newestOnTop
					/>
					<QueryClientProvider client={queryClient}>
						<ReactQueryDevtools />
						<BrowserRouter>
							<Main />
						</BrowserRouter>
					</QueryClientProvider>
				</Suspense>
			</PersistGate>
		</Provider>
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
